/* eslint-disable */
<template>
  <div id="learner-table">

      <v-container v-if="!learnerDataLoaded" class="loader">
        <v-progress-circular indeterminate size=70 :width="5">
        </v-progress-circular>
      </v-container>


      <!--classes table-->
      <el-table
      v-if="activeViewLearners === 'Classes' && learnerDataLoaded"
      :data="classes.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          header-align="center"
          align="center"
          width="50"
          prop=""
          label="">
          <template slot-scope="scope">
            <v-icon :color="scope.row.default_color">folder_shared</v-icon>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          min-width="200"
          prop="name"
          label="Class Name">
          <template slot-scope="scope">
            <span
              class="branded-text cursor tabable-first classname"
              :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]"
              tabindex="1"
              :aria-label="createAriaLabel('classes', scope.row)"
              @click="setNavData([learnerData.migrated ? 'Gradebook' : 'Bulbs', {section_id:scope.row.id}, scope.row.name, null])"
              @keyup.enter="setNavData([learnerData.migrated ? 'Gradebook' : 'Bulbs', {section_id:scope.row.id}, scope.row.name, null])">
              {{scope.row.name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="300"
          prop="instructors"
          label="Instructors">
          <template slot-scope="scope">
             <div @click="showInstructors(scope.row)" class="learner-teacher-container" v-if="updateInstructors">
               <el-tag v-for="(teacher, index) in scope.row.instructors" v-if="(showAllInstructors[scope.row.id]) ? index > -1 : index <= 2" :key="index" type="info" style="margin:5px;">{{teacher}}</el-tag>
               <el-tag  v-if="scope.row.instructors.length > 3 && !showAllInstructors[scope.row.id]" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">...</el-tag>
               <el-tag  v-if="scope.row.instructors.length > 3 && showAllInstructors[scope.row.id]" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">
                 <v-icon small>clear</v-icon>
               </el-tag>
             </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          header-align="center"
          align="center"
          prop="timestamp"
          label="Joined">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Remove">
          <template slot-scope="scope">
            <v-btn flat icon class="branded-grey tabable-first"   @click="handleDialogOpen({type:'confirm', data:{type:'removeClass', data:scope.row}})" tabindex="1" :aria-label="createAriaLabel('remove', scope.row)">
              <v-icon class="selectable" tabindex="-1" >delete</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>



      <!--bulbs table-->
      <el-table
      v-if="activeViewLearners === 'Bulbs' && learnerDataLoaded"
      :data="bulbs.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope">
            <div class="column" style="height:50px;">
              <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                <div class="thumbnail-wrapper-nonselect" :style="thumbnailStyle(scope.row.thumbnail)"></div>
              </v-responsive>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          min-width="200"
          prop="name"
          align="left"
          label="Bulb">
          <template slot-scope="scope">
            <span
              v-if="isBulbEligibleForSubmission(scope.row)"
              class="bulb-title-cell"
              @click="launchBulb(scope.row)"
              @keyup.enter="launchBulb(scope.row)"
              tabindex="1"
              :aria-label="createAriaLabel('bulbs', scope.row)"
            >
              <Tooltip top>
                <div
                  class="branded-text cursor bulb-tab tabable-first"
                  :class="[ isSafari ? 'safari-bulb-name-truncate-folders-table' : 'bulb-name-truncate' ]"
                  >
                  {{scope.row.name}}
                </div>
                <template v-slot:text>
                  {{scope.row.name}}
                </template>
              </Tooltip>
            </span>
            <span
              v-else
              class="bulb-title-cell"
              tabindex="1"
              :aria-label="createAriaLabel('bulbs', scope.row)"
            >
              past due date
              <div>
                <Tooltip class="item" top>
                  <div class="bulb-tab tabable-first">{{scope.row.name}}</div>
                  <template v-slot:text>
                    The deadline for this bulb has passed
                  </template>
                </Tooltip>
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          prop=""
          label="">
          <template slot-scope="scope">
            <v-chip v-if="_.has(scope.row, 'config.lmb') && !scope.row.config.lmb.peer_review" color="blue" text-color="blue" small outline tab-index="-1">LMB</v-chip>
            <v-chip v-if="_.get(scope.row, 'config.lmb.peer_review')" color="primary" text-color="blue" small outline tab-index="-1">Peer Review</v-chip>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          header-align="center"
          align="center"
          width="250"
          prop="assigned_date"
          label="Due Date">
        </el-table-column>
        <el-table-column
          width="300"
          align-header="center"
          align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.complete === 0" type="warning">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.complete === 1" type="success">{{scope.row.status}}</el-tag>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>
      
      <!--playlists table-->
      <el-table
      v-if="activeViewLearners === 'Playlists' && learnerDataLoaded"
      :data="learnerSectionPlaylists"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          align="center"
          width="50">
          <template slot-scope="scope">
            <v-icon>playlist_play</v-icon>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          sortable="custom"
          min-width="200"
          align="left"
          label="Playlist">
          <template slot-scope="scope">
            <span
              class="bulb-title-cell"
              @click="launchPlaylist(scope.row.id)"
              @keyup.enter="launchPlaylist(scope.row.id)"
              tabindex="1"
              :aria-label="createAriaLabel('playlist', scope.row)"
            >
              <Tooltip top>
                <div
                  class="branded-text cursor bulb-tab tabable-first"
                  :class="[ isSafari ? 'safari-bulb-name-truncate-folders-table' : 'bulb-name-truncate' ]"
                  >
                  {{ scope.row.name }}
                </div>
                <template v-slot:text>
                  {{ scope.row.name }}
                </template>
              </Tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          header-align="center"
          align="center"
          width="250"
          prop="assignedDate"
          label="Due Date">
          <template slot-scope="scope">
            {{formatPlaylistDueDate(scope.row.sections[0].playlistSection.assignedDate)}}
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--student gradebook table-->
      <el-table
      v-if="activeViewLearners === 'Gradebook' && learnerDataLoaded"
      :data="gradebook.data"
      style="width: 100%"
      :max-height="maxHeight"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="75">
          <template slot-scope="scope">
            <div class="column" style="height:50px;">
              <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                <div class="thumbnail-wrapper-nonselect" :style="thumbnailStyle(scope.row.thumbnail)"></div>
              </v-responsive>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="Bulb"
          sortable="custom"
          width="300">
          <template slot-scope="scope">
            <Tooltip top>
              <span
                v-if="scope.row.lmb_id != 1"
                class="branded-text cursor gradebook-tab tabable-first"
                :class="[ isSafari ? 'safari-bulb-name-truncate-folders-table' : 'bulb-name-truncate' ]"
                @click="studentInteractionNav(scope.row)"
                @keyup.enter="studentInteractionNav(scope.row)"
                tabindex="1"
                :aria-label="createAriaLabel('gradebook', scope.row)">
                {{ scope.row.name }}
              </span>
              <span v-else-if="scope.row.lmb_id === 1">{{ scope.row.name }}</span> 
              <template v-slot:text>
                {{ scope.row.name }}
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          prop=""
          label="">
          <!-- <template slot-scope="scope">
            <v-btn flat text class="branded-text branded-border"  @click="lmbMonitorNav(scope.row, 'Gradebook')" v-if="scope.row.lmb_id === 1 && (scope.row.config.lmb.data || scope.row.config.lmb.anonymous)  && scope.row.complete === 1">
              <v-icon style="font-size: 18px; padding-right: 8px;">view_list</v-icon>
              Monitor
            </v-btn>
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          min-width="150"
          prop="points"
          label="Points">
        </el-table-column>
        <el-table-column
          min-width="150"
          header-align="center"
          align="center"
          prop="score"
          sortable="custom"
          label="Score">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="engaged_minutes"
          sortable="custom"
          width="175"
          label="Time Spent (min)">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="200"
          prop="completion_time"
          sortable="custom"
          label="Completed">
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>


      <!--student interaction table-->
      <el-table
      v-if="activeViewLearners === 'Student-Interaction' && learnerDataLoaded"
      :data="studentinteraction.data"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      :row-class-name="rowHeight"
      >
        <el-table-column
          prop=""
          label=""
          align="center"
          width="70">
          <template slot-scope="scope">
            <v-icon>{{interactionIconMap[scope.row.interaction_type]}}</v-icon>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          width="250"
          header-align="center"
          align="center"
          prop="display_in_time"
          label="Interaction Timestamp">
        </el-table-column>
        <el-table-column
          width="150"
          header-align="center"
          align="center"
          prop="time_elapsed"
          label="Time Spent (sec)">
        </el-table-column>
        <el-table-column
          width="150"
          header-align="center"
          align="center"
          prop="points"
          label="Points">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          min-width="200"
          prop="response.text"
          label="Answer">
          <template slot-scope="scope">
              <el-popover trigger="manual" v-model="menus.studentInteraction[scope.row.interaction_id]" placement="left" width="300">
                <div class="popover-content-wrapper">
                  <div class="question_header">
                    <v-icon color="white">{{interactionIconMap[scope.row.interaction_type]}}</v-icon>
                  </div>
                  <PlaypositInteraction
                    v-if="menuData.studentInteraction[scope.row.interaction_id]"
                    :bulb-id="parseInt(queryParamsLearners.bulb_id, 10)"
                    :section-id="parseInt(queryParamsLearners.section_id, 10)"
                    :student-id="parseInt(learnerData.id, 10)"
                    :interaction-id="parseInt(scope.row.interaction_id, 10)"
                    :token="learnerData.token"
                    :restrict-discussion-comments-by-student-id="learnerData.id"
                    :setViewedComments="setViewedComments"
                    topper="review"
                    user-type="student"
                    discussion-role="observer"
                    perspective="answered"
                  />
                </div>
                <div
                  slot="reference"
                  @click="openAnswerPopover({
                    key: 'studentInteraction',
                    id: scope.row.interaction_id,
                  })"
                  @keyup.enter="openAnswerPopover({
                    key: 'studentInteraction',
                    id: scope.row.interaction_id,
                  })"
                  class="cursor row-center popup tabable-first answer-tab center"
                >
                  <GradeCell
                    class="full-width mt-3"
                    user-type="student"
                    :question="scope.row"
                    :data="scope.row"
                    :view="activeViewLearners"
                  ></GradeCell>
                </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="explanation"
          label=""
          width="200">
          <template slot-scope="scope">
            <div :class="scope.row.explanation ? 'free-response-answer' : ''">{{scope.row.explanation}}</div>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

     <!--lmb table-->
     <!-- -->
      <el-table
      v-if="activeViewLearners === 'LMB-Monitor' && learnerDataLoaded"
      :data="lmb.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @sort-change="sortChange"
      >
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          min-width= "100"
          prop="score"
          label="Score">
        </el-table-column>
        <el-table-column
          width= "150"
          header-align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 0" type="warning">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 1" type="success" class="cursor">{{scope.row.status}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="question in lmb.headers"
          width="150"
          align="center"
          :key="question.interaction_id"
          >
          <template slot="header" slot-scope="scope">
            <div class="question-header">
              <el-popover trigger="click" placement="bottom"  width="170">
                <div>
                  <div class="action-button">
                    <v-btn flat text  class="branded-grey" @click="openInteractionModal(question)">
                      <v-icon small style="padding-right: 8px;">insert_chart</v-icon>
                      Interaction Data
                    </v-btn>
                  </div>
                </div>
                <div slot="reference" class="interaction-header">
                  <div class="interaction-question-icon cursor">
                    <v-icon>{{interactionIconMap[question.interaction_type]}}</v-icon>
                    <h5 class="cursor question-timestamp">{{question.display_in_time}}</h5>
                  </div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <el-popover
              trigger="click"
              placement="left"
              width="375"
              :disabled="!scope.row[question.interaction_id]"
              v-model="menus.studentLmb[question.interaction_id]"
            >
                <div class="popover-content-wrapper">
                  <div class="question_header">
                    <v-icon color="white">{{interactionIconMap[scope.row.interaction_type]}}</v-icon>
                  </div>
                  <PlaypositInteraction
                    v-if="menuData.studentLmb[question.interaction_id]"
                    :bulb-id="parseInt(queryParamsLearners.bulb_id, 10)"
                    :section-id="parseInt(queryParamsLearners.lmb_section, 10)"
                    :student-id="parseInt(scope.row.id, 10)"
                    :interaction-id="parseInt(question.interaction_id, 10)"
                    :token="learnerData.token"
                    :restrict-discussion-comments-by-student-id="scope.row.id"
                    :setViewedComments="setViewedComments"
                    topper="review"
                    user-type="student"
                    discussion-role="observer"
                    perspective="answered"
                  />
                </div>
                <div slot="reference" :class="scope.row[question.interaction_id] ? 'cursor popup' : ''">
                  <div v-if="scope.row[question.interaction_id]">
                    <GradeCell
                      class="mt-3"
                      user-type="student"
                      :question="question"
                      :data="scope.row[question.interaction_id]"
                      :view="activeViewLearners"
                    ></GradeCell>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div>
              </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

  </div>
</template>

<script>
import _ from 'lodash';
import router from '../../router';
const Color = require('color');
import { mapState, mapGetters, mapMutations} from 'vuex';
import Discussion from '../Discussion';
import GradeCell from '../GradeCell';
import Hashids from 'hashids';
import {
  addSortAccessibiltyEvents,
  waitForElementToDisplay,
} from '@utilities';
const moment = require('moment');

const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'learner-table-component',
  components: {
    Discussion,
    GradeCell,
  },
  data() {
    return {
      maxHeight: '',
      explanation_grade_student: {},
      showAllInstructors:{},
      updateInstructors: true,
      discussion: {
        toggle: false,
        id: null
      },
      menus: {
        studentInteraction: {},
        studentLmb: {},
      },
      menuData: {
        studentInteraction: {},
        studentLmb: {},
      },
    };
  },
  computed: {
    ...mapState('learners', [
      'initialSectionId',
      'learnerSectionHasPlaylist',
      'learnerSectionPlaylists',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'learnerData',
      'dialogShow',
      'username',
      'nodeApiPrefix',
      'phpApiPrefix',
      'playerApiPrefix',
      'designerApiPrefix',
      'instructorData',
      'interactionIconMap',
      'interactionTypeMap',
      'userAgent',
    ]),
    ...mapGetters('learners', [
      'activeViewLearners',
      'learnersAjaxing',
      'queryParamsLearners',
      'learnerDataLoaded',
      'classes',
      'selectedData',
      'bulbs',
      'gradebook',
      'learnerGradebookBreadcrumbs',
      'studentinteraction',
      'lmb',
      'refreshData'
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
    ]),
    activeViewData: function(){
      //returns change in data to populate grading object
      return [this.activeViewLearners, this.learnerDataLoaded];
    },
    dialogOpen: function(){
      return(this.dialogShow.dash || this.dialogShow.toolbar || this.dialogShow.table || this.dialogShow.learner)
    },
    isSafari() {
      return _.get(this, 'userAgent.browser.name', '').toLowerCase() === 'safari';
    },
  },
  methods:{
    ...mapMutations([
      'handleDialogOpen',
      'setViewedComments',
    ]),
    formatPlaylistDueDate(date) {
      if (date) return moment(date).format('MMM DD, YYYY hh:mm A');
      return 'No Assigned Date';
    },
    isBulbEligibleForSubmission(bulb) {
      return (
        process.env.NODE_ENV === 'development'
        || !_.get(bulb, 'school_config.permissions', []).includes('bulbDueDate')
        || _.get(bulb, 'is_before_submission_deadline', true)
      );
    },
    //run at create
    getData: function(){
      this.maxHeight =  ((window.innerHeight - 215) < 300) ? 300 : (window.innerHeight - 215);
    },
    //table navigation functions
    setNavData: function(array) {
      //sets array data
      let active_view = array[0];
      let query_params = array [1];
      let breadcrumbText = array[2];
      let secondaryBreadcrumb = array[3];
      //declares breadcrumb and payload variables
      let breadcrumb;
      let payload = {};

      if(breadcrumbText != null){
        //if breadcrumbText is not null, add active breadcrumb to return to active base side nav view
        breadcrumb = [{text:`${this.learnerData.firstName}'s Classes` ,  payload:this.activeView}, {text:breadcrumbText,  payload:''}];
        payload[this.activeView] = {route:'learner', activeView:this.activeView, activeViewRoute:this.activeViewLearners, queryParams:{}, breadcrumb:[{text:`${this.learnerData.firstName}'s Classes` , payload:''}]}
      } else if (secondaryBreadcrumb[0] != null){
        //if secondary breadcrumb is not null, sets gradebook breadcrumb
        breadcrumb = this.breadcrumbs;
        breadcrumb.push(secondaryBreadcrumb[0]);
        if(this.activeViewLearners === 'Bulbs'){
          payload['Learner-Bulbs'] = secondaryBreadcrumb[1];
        }
        if(this.activeViewLearners === 'Gradebook'){
          payload['Learner-Gradebook'] = secondaryBreadcrumb[1];
        }
      }
      //updates breadcrumbs, query params, active view and url
      this.$store.commit('updateBreadCrumbs' , [breadcrumb, payload]);
      this.$store.commit('learners/resetQueryParams');
      this.$store.commit('learners/setQueryParams', query_params)
      this.$store.commit('learners/setActiveView', [active_view]);
      this.$store.dispatch('learners/updateUrl');
    },
    studentInteractionNav:function(data){
      //table navigation into student bulb interaction table
      //copies current breadcrumb
      let breadcrumbCopy = this.breadcrumbs.slice();
      //creates a gradebook breadcrumb and payload
      let breadcrumb = {text:'Gradebook',  payload:'Learner-Gradebook'};
      let payload = {route:'learner', activeView: 'Learner', activeViewRoute:'Gradebook', queryParams:{section_id: this.queryParamsLearners.section_id}, breadcrumb: breadcrumbCopy}

      //sets gradebook breadcrumb with the name of the bulb
      this.$store.commit('learners/setGradebookBreadcrumbs', [{text:data.name, payload: ''}]);
      //updates query params and calls the setNavData function
      this.$store.commit('learners/setQueryParams', {page:1, per_page: 10, sort:'', search: ''});
      this.setNavData(['Student-Interaction', {section_id: this.queryParamsLearners.section_id, bulb_id: data.bulb_id}, null, [breadcrumb , payload]]);
    },
    lmbMonitorNav:function(data, type){
       //table navigation into student bulb interaction table
      //copies current breadcrumb
      let breadcrumbCopy = this.breadcrumbs.slice();
      //creates a gradebook breadcrumb and payload
      let breadcrumb;
      let payload;
      if(type === 'Bulbs'){
        breadcrumb = {text:'Bulbs',  payload:'Learner-Bulbs'};
        payload = {route:'learner', activeView: 'Learner', activeViewRoute:'Bulbs', queryParams:{section_id: this.queryParamsLearners.section_id}, breadcrumb: breadcrumbCopy}
      }
      if(type === 'Gradebook'){
        breadcrumb = {text:'Gradebook',  payload:'Learner-Gradebook'};
        payload = {route:'learner', activeView: 'Learner', activeViewRoute:'Gradebook', queryParams:{section_id: this.queryParamsLearners.section_id}, breadcrumb: breadcrumbCopy}
      }

      //sets gradebook breadcrumb with the name of the bulb
      this.$store.commit('learners/setGradebookBreadcrumbs', [{text:`Monitor Data: ${data.name}`, payload: ''}]);
      //updates query params and calls the setNavData function
      this.$store.commit('learners/setQueryParams', {page:1, per_page: 10, sort:'', search: ''});
      this.setNavData(['LMB-Monitor', {lmb_bulb: data.lmb_bulb_id, lmb_section: data.lmb_section_id}, null, [breadcrumb , payload]]);
    },
    openAnswerPopover({
      key,
      id,
    } = {}) {
      _.set(this, `menus.${key}`, {
        [id]: !_.get(this, `menus.${key}.${id}`)
      });
    },
    resetMenus() {
      for (const key in this.menus) {
        this.$set(this.menus, key, {});
      }
    },
    closePopovers: function(event){
      if((Array.from(event.target.classList).indexOf('student-answers') < 0) && (Array.from(event.target.classList).indexOf('el-popover__reference') < 0) && (Array.from(event.target.classList).indexOf('show-discussion') < 0) && (Array.from(event.target.classList).indexOf('refresh-discussion-id') < 0) && (Array.from(event.target.classList).indexOf('discussion-popover') < 0) && event.target != document.body){
        this.resetMenus();
      }
    },
    /** 
     * This function is sloppy and honestly is upsetting to read.
     * It handles sorting the tables when clicked.  Since I added keyboard events
     * it needed to be more specific and not just flip flop between ASC/DESC
     * 
     * @param event {
     *   column - the column from the table *not used in function or provided if event triggered by keyboardEvent*
     *   prop - the name of the data table prop used in the column
     *   order - 'ascending' or 'descending'
     * }
    */
    sortChange: function (event) {
      if (!this.learnersAjaxing) {
        let queryParams;
        if (
          this.queryParamsLearners.sort === ''
          && event?.column
        ) {
          // if sort is not set, set sort to column prop ascending
          queryParams = { sort: `${event.prop} ASC` };
        } else if (!event?.column) { // event triggered by keyboardEvent
          const order = event.order === 'ascending' ? 'ASC' : 'DESC';
          queryParams = { sort: `${ event.prop} ${ order }` };
        } else {
          // if sort is set, find name and order
          let name = this.queryParamsLearners.sort.split(' ')[0];
          let order = this.queryParamsLearners.sort.split(' ')[1];
          /**
           * This is needed because an accurate sort order is not passed when a column header
           * is clicked.  Instead the event.order *always* = 'ascending'  ¯\_(ツ)_/¯
          */
          if (event.prop != name) {
            //if it is a new name, set sort to new column name ascending
            queryParams = { sort: `${event.prop} ASC` };
          } else if (
            event.prop === name
            && order === 'ASC'
          ) {
            // if it is the same column and asc, change to desc
            queryParams = { sort: `${event.prop} DESC` };
          } else if (
            event.prop === name
            && order === 'DESC'
          ) {
            // if it is the same column and desc, change to asc
            queryParams = { sort: `${event.prop} ASC` };
          }
        }
        //sets query params, calls for data tables/and updates url
        this.$store.commit('learners/setQueryParams', queryParams);
        this.$store.dispatch('learners/getTableData');
        this.$store.dispatch('learners/updateUrl');
      }
    },
    sortChangeTab: function(event){

      if(event.key === "Enter"){
        let queryParams = {};
        let column = event.target.parentElement.parentElement.childNodes[0].data;
        let sortColumn = '';
        switch(column){
          case 'Bulb':
            sortColumn = 'name';
            break;
          case 'Class Name':
            sortColumn = 'name';
            break;
          case 'Class Name':
            sortColumn = 'name';
            break;
          case 'Due Date':
            sortColumn = 'assigned_date';
            break;
          case 'Joined':
            sortColumn = 'timestamp';
            break;
          case 'Completed':
            sortColumn = 'timestamp';
            break;
          case 'Score':
            sortColumn = 'score';
            break;
          case 'Time Spent (min)':
            sortColumn = 'engaged_minutes';
            break;
          case 'Interaction Timestamp':
            sortColumn = 'display_in_time';
            break;
        }

        if(event.target.className.indexOf('ascending') >= 0){
          queryParams.sort = `${sortColumn} ASC`;
        } else {
          queryParams.sort = `${sortColumn} DESC`;
        }

        //sets query params, calls for data tables/and updates url
        this.$store.commit('learners/setQueryParams', queryParams);
        this.$store.dispatch('learners/getTableData');
        this.$store.dispatch('learners/updateUrl');
      }
    },
    createAriaLabel:function(type, data){
      if(type === 'classes'){
        return `Class named ${data.name}. Instructed by ${data.instructors.join(',')}. Joined on ${data.timestamp}. Press enter to access bulbs and gradebook for this class.`
      }
      if(type === 'remove'){
        return `Remove class button. Press enter to remove ${data.name} from your class list`;
      }
      if(type === 'bulbs'){
        const lmbType = (() => {
          if (_.has(data, 'config.lmb')) {
            return _.get(data, 'config.lmb.peer_review') ? 'Peer Review' : 'LMB';
          } else {
            return ''
          }
        })();
        return `${lmbType} Bulb named ${data.name}. Due on ${data.assigned_date}. Status is ${data.status}. Click here to play bulb.`
      }
      if(type === 'gradebook'){
        return `Grades for ${data.name}. Score of ${data.score}. Minutes spent on this bulb is ${data.engaged_minutes}. ${(data.timestamp === 'In Progress') ? 'This bulb is In progress.' : `This bulb was completed on ${data.timestamp}`}. Press enter to view interaction data for this bulb.`
      }
      if(type === 'interaction'){
        return `This is a ${(data.interaction_type.includes('_'))? data.interaction_type.replace('_', ' ') : data.interaction_type} interaction. It is at ${data.display_in_time} in the bulb. You spent ${data.time_elapsed} seconds on this interaction. You earned ${data.points} points. The interaction says`
      }
      if (type === 'playlist') {
        return `Playlist ${data.name}`;
      }
    },
    //function to handle selection
    selectionChange:function(event){
      //save selected data to state
      this.$store.commit('instructors/setSelectedData', event);
    },
    showInstructors:function(row){
       if(row.instructors.length > 3){
         this.showAllInstructors[row.id] ? this.showAllInstructors[row.id] = false : this.showAllInstructors[row.id] = true;
         //set updateInstructors to false to force a reload of the dom
         this.updateInstructors = false;
         setTimeout(() => this.updateInstructors = true, .05);
       }
    },
    async launchBulb(bulb) {
      if (bulb.lmb_id == 1) {
        if (_.get(bulb, 'config.lmb.peer_review')) {
          window.open(`/dash/?token=${this.learnerData.token}&launch_endpoint=${encodeURIComponent('launch/lmb')}&bulb_id=${bulb.id}&section_id=${this.queryParamsLearners.section_id}`);
        }
        else {
          // Regular LMB
          if (!bulb.lmb_bulb_id) {
            this.$store.dispatch('learners/createLMB', {id:bulb.id, section_id: this.queryParamsLearners.section_id});
          } else {
            if (bulb.complete === 0) {
              window.open(`${this.designerApiPrefix}/designer/?bulb_id=${bulb.lmb_bulb_id}&section_id=${this.queryParamsLearners.section_id}&token=${this.instructorData.token}`);
            } else {
              window.open(`${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${bulb.lmb_bulb_id}&token=${this.instructorData.token}&lms_launch=false&section_id=${bulb.lmb_section_id}`);
            }
          }
        }
      } else {
        //opens up player
        window.open(`${this.playerApiPrefix}/player_v2/?section_id=${this.queryParamsLearners.section_id}&type=bulb&bulb_id=${bulb.id}&token=${this.learnerData.token}&lms_launch=false${this.activeViewInstructor ? '&pd=true' : ''}`);
      }
    },
    launchPlaylist(playlistId) {
      window.open(`${this.phpApiPrefix}/playlist/${hashids.encode([playlistId, this.queryParamsLearners.section_id])}?access_token=${this.learnerData.token}&preview=true`);
    },
    broadcast:function(bulb){
      //opens up player
      this.$store.commit('triggerSnackbar', {text:`This feature is coming soon!`, color: 'green', timeout: 6000} , {root:true});
    },
    remove:function(data){
      //confirms, then calls removeClass
      if(confirm(`Would you like to remove "${data.name}" from your class list?`)){
        this.$store.dispatch('learners/removeClass', data.id);
      }
    },
    //functions to add css classes to columns and rows
    sortClasses: function (event) {
      //change header class based on the current sort
      if (!this.learnersAjaxing && this.selectedData.length === 0) {
        let sortArray = this.queryParamsLearners.sort.split(" ");
        //if sort set, finds asc or desc and returns correct class
        let sortClass;
        if (_.snakeCase(event.column.property) === sortArray[0]) {
          (sortArray[1] === 'DESC') ? sortClass = 'descSelected' : sortClass = 'ascSelected';
          return sortClass;
        } else {
          //if no sort, returns noSelected class
          return 'noSelected';
        }
      }
    },
    thumbnailColumn:function(event){
      //if thumbnail in table, sets class to have no padding
      if(event.columnIndex == 0){
        return 'no-padding';
      }
    },
    thumbnailStyle:function(url){
      return {
        backgroundImage: `url("${url}")`
      }
    },
    rowHeight:function(event){
      //sets row height at 40px in student interaction table
      return 'row-height'
    },
    //functions to support accessibility
    addTabToSort: function(){
      let sorting = document.getElementsByClassName('sort-caret');
      Array.from(sorting).forEach(sort => {
        sort.setAttribute('tabindex', "0");
        let text = sort.parentElement.parentElement.innerText;
        let order = 'ascending';
        if(Array.from(sort.classList).indexOf('ascending') == -1){
          order = 'descending'
        }
        sort.setAttribute('aria-label', `sort by ${text} ${order}`)
        sort.addEventListener('keypress', this.sortChangeTab);
      })
    },
    removeTabToSort: function(){
      let sorting = document.getElementsByClassName('sort-caret');
      Array.from(sorting).forEach(sort => {
        sort.setAttribute('tabindex', "-1");
        sort.addEventListener('keypress', this.sortChangeTab);
      })
    },
    addPopoverListener: function(){
      document.addEventListener('click', this.closePopovers);
      document.addEventListener('keyup', this.closePopovers);
      window.addEventListener('resize', this.adjustMaxHeight)
    },
    removePopoverListener: function(){
      document.removeEventListener('click', this.closePopovers);
      document.removeEventListener('keyup', this.closePopovers);
      window.removeEventListener('resize', this.adjustMaxHeight)
    },
    adjustMaxHeight: function(event){
      this.maxHeight =  window.innerHeight - 215;
    },
  },
  watch: {
    activeViewData: {
      handler: async function (val, oldVal) {
        //watcher for data load to create the explanation_grade_student object
        if(val[0] === "Student-Interaction" && val[1]) {
          this.studentinteraction.data.forEach((item, i)=> this.$set(this.explanation_grade_student, item.id,  item.explanation_graded));
        }
        if (val[1]) { // val[1] = learnerDataLoaded
          const caretWrapper = await waitForElementToDisplay('.caret-wrapper')
          if (caretWrapper) addSortAccessibiltyEvents(this.sortChange, this.activeView, this.activeViewLearners);
        }
      }
    },
    refreshData: {
      handler: function(val){
        if(val){
          //watches for changes in refresh data and calls for data and resets watcher
          this.$store.commit('learners/refreshComplete');
          this.$store.dispatch('learners/getTableData');
        }
      }
    },
    learnerDataLoaded: {
      handler: function(val){
        if (val){ //watches if learner data is loaded
          if (this.initialSectionId) { // initialSectionId to redirect directly to a class
            this.setNavData(
              [
                'Bulbs',
                {
                  section_id: parseInt(this.initialSectionId, 10)
                },
                _.find(this.classes.data, { id: this.initialSectionId }).name || `NTC Section - ${ this.initialSectionId }`,
                null,
              ],
            );
          }
          if(this.activeViewLearners === "Classes"){
            //if classes, creates show all instructor toggle if more than 3 instructors
            this.classes.data.forEach(sec => {
              if(sec.instructors.length > 3){
                this.showAllInstructors[sec.id] = false;
              }
            })
          }
          if(this.activeViewLearners === "Student-Interaction"){
            //if classes, creates show all instructor toggle if more than 3 instructors
            this.resetMenus();
          }

          this.addTabToSort();
        }
      }
    },
    dialogOpen: {
      handler: function(val){
        if(val){
          this.removeTabToSort();
        } else {
          this.addTabToSort();
        }
      }
    },
    menus: {
      handler(n, o) {
        for (const key in n) {
          for (const innerKey in n[key]) {
            if (n[key][innerKey]) {
              this.menuData[key][innerKey] = true;
            }
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.addPopoverListener();
  },
  updated() {
  },
  beforeDestroy(){
    this.removePopoverListener();
  }
};
</script>

<style scoped>
  #learner-table{
   width: 100%;
   padding: 0px 36px;
  }

  .bulb-title-cell {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .full-width {
    width: 100%;
  }
</style>


